<template>
  <div class="blog">
    <div class="container background-container">
      <div class="row">
        <div class="col-md-12 p-0 pt-4">
          <img
            class="blog__header-image"
            src="@/assets/images/blog/babacooks/header.jpg"
            alt="header-image"
          />
        </div>
      </div>
    </div>

    <div class="container p-md-0">
      <div class="row">
        <div class="col-md-12 p-md-0">
          <h1 class="blog__title">
            Owner of award-winning restaurants proves his cooking prowess...
          </h1>
        </div>
      </div>

      <div class="row position-relative">
        <div
          v-if="userAgent && !isInstagramBrowser"
          class="blog__social d-md-flex d-none"
        >
          <span class="blog__social-title">Share</span>
          <div
            v-for="(link, key) in socialLinks"
            :key="key"
            class="mt-2"
            @click="handleShareClick"
          >
            <img :src="getImageItem(key)" :alt="key" />
          </div>
        </div>
        <div class="col-md-8 offset-md-2">
          <p>
            THE OWNER of two award-winning Northeast restaurants – who admits he
            couldn’t cook pre-lockdown – is now proving an online hit with his
            recipes.
          </p>
          <p>
            Elahi Amin, who owns My Delhi in Newcastle and Sunderland, has
            always been front of house when it comes to managing his businesses.
          </p>
          <p>
            But after taking to social media to share some of own versions of
            classic Asian food he now has more than 300,000 followers – which
            has led to the publication of his own cookbook.
          </p>

          <img
            class="blog__landscape-image"
            src="@/assets/images/blog/babacooks/2.jpg"
            alt="image"
          />

          <p>
            Baba Cooks features a whole host of Elahi’s favourite family
            recipes, which as a baba (dad) he made for his children to enjoy.
          </p>
          <p>
            As well as Indian dishes he has created a range of Italian specials
            and even his own versions of popular fast food, as well as fusion
            offerings such as Tandoori Chicken Pasta.
          </p>
          <p>
            Although Elahi has always been involved in hospitality – his father
            owned a popular Indian restaurant in South Shields and all of his
            brothers also work in the industry – the online success has come as
            a huge surprise.
          </p>
          <p>
            “Like lots of people I just started to cook during Covid,” he said.
          </p>
          <p>
            “I’m not a chef, although I’ve picked up bits and pieces from the
            chefs, I’ve worked with over the years, but I just started to do my
            own versions.
          </p>
          <p>
            “It was my daughter who suggested I posted some of them on Tik Tok
            and I just couldn’t believe the response, it just went crazy.
          </p>

          <div class="blog__quote my-5">
            <p>
              “So, when the opportunity came to do a cookery book – which was
              something I always wanted to do – I just couldn’t turn it down,”
            </p>
          </div>

          <p>
            Baba Cooks has been published by Found, which specialises in turning
            social media content into books, with no financial commitment from
            the creator.
          </p>
          <p>
            The only obligation from the influencer is to promote the book via
            their platforms, and using Found’s print on demand capability, the
            creator gets a percentage of every book sold.
          </p>
          <p>“It’s going really well, better than I ever hoped,” said Elahi</p>
          <p>
            “So much so that I’d like to do a second book. I’ve had requests for
            it from around the world – from Nigeria, Dubai and Ghana. It’s been
            fantastic.”
          </p>
          <p>
            It’s the latest in a long line of successes for the ambitious Elahi,
            who also works for Newcastle City Council part time in digital
            marketing and is about to launch a new restaurant.
          </p>
        </div>

        <div class="col-md-8 offset-md-2">
          <div class="blog__double-image">
            <img src="@/assets/images/blog/babacooks/3.jpg" alt="image" />
            <img src="@/assets/images/blog/babacooks/4.jpg" alt="image" />
          </div>
        </div>

        <div class="col-md-8 offset-md-2 mt-3">
          <p>
            My Delhi has been a huge success, previously winning Britain’s Top
            Takeaway on television.
          </p>
          <p>
            “It’s great having fantastic chefs who have been able to help me
            along my cooking journey,” said Elahi.
          </p>
          <p>
            “I can’t believe what’s happened in such a short space of time and
            having the cookery book has been an absolutely amazing opportunity.”
          </p>

          <div
            v-if="userAgent && !isInstagramBrowser"
            class="blog__social d-md-none"
          >
            <span class="blog__social-title">Share</span>
            <div class="d-flex">
              <div
                v-for="(link, key) in socialLinks"
                :key="key"
                class="mt-2 mr-md-0 mr-3"
                @click="handleShareClick"
              >
                <img :src="getImageItem(key)" :alt="key" />
              </div>
            </div>
          </div>

          <div v-if="tags && tags.length">
            <h2 class="mt-4">Related topics</h2>
            <div class="blog__tags">
              <Tag
                v-for="tag in tags"
                :key="tag"
                class="mr-3 my-2"
                @click="onTagClick(tag)"
              >
                {{ tag }}
              </Tag>
            </div>
          </div>

          <div class="blog__action-button mt-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              @click="handleBeFoundClick"
            >
              I’m ready to talk
            </Button>
          </div>

          <div class="blog__action-button mt-3 mb-5">
            <Button
              class="pt-2"
              full-width
              size="sm"
              variant="outline"
              @click="$router.push('/blog')"
            >
              View all blogs
            </Button>
          </div>

          <Carousel
            v-if="creatorProducts && creatorProducts.length"
            id="blog-products"
            class="my-4"
            :items="creatorProducts"
            :mode="CarouselModes.PRODUCT"
            show-default-item-actions
            @click="handleProductBundleClick"
          >
            <template #title>
              <h2>More from {{ creatorHandle }}</h2>
            </template>
          </Carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { throttle } from 'lodash';
import socialLinks from '@/misc/socialLinks';
import { CarouselModes, WebApiCancelError } from '@/misc/constants';
import Tag from '@/components/Elements/Tag.vue';
import Button from '@/components/Elements/Button.vue';
import getDefaultProductFormat from '@/misc/getDefaultProductFormat';
import formatMoney from '@/misc/formatMoney';
import getFormatPrice from '@/misc/getFormatPrice';
import { fetchProductsByCreator } from '@/services/products';
import filterProductsByRegion from '@/misc/filterProductByRegion';

export default {
  name: 'BlogItemPage',
  components: {
    Button,
    Tag,
    Carousel: () =>
      import(/* webpackPrefetch: true */ '@/components/Carousel/Index')
  },

  data() {
    return {
      creatorHandle: 'itsbabacooks',
      CarouselModes,
      socialLinks,
      buyNowLoading: false,
      creatorProducts: [],
      tags: ['Creator Stories']
    };
  },

  head: {
    title: 'Be Found | Blog'
  },

  computed: {
    ...mapState('main', ['userAgent']),
    ...mapGetters({
      redirectUrl: 'checkout/redirectUrl',
      isInstagramBrowser: 'main/isInstagramBrowser',
      currency: 'config/currency',
      region: 'config/region'
    })
  },

  mounted() {
    fetchProductsByCreator(this.$axios, this.creatorHandle)
      .then((response) => {
        const creatorProducts = this.$get(response, 'creatorProducts');
        this.creatorProducts = filterProductsByRegion(
          creatorProducts,
          this.region
        );
        this.contributedProducts = filterProductsByRegion(
          this.$get(response, 'contributedProducts'),
          this.region
        );
      })
      .catch((err) => {
        this.$showToastMessage(
          this.$get(err, 'response.data.message'),
          'Error',
          'danger'
        );
      });
  },

  methods: {
    ...mapMutations({
      ADD_ITEM: 'checkout/ADD_ITEM'
    }),
    ...mapActions({
      createSession: 'checkout/createSession'
    }),
    getImageItem(key) {
      return require(`@/assets/icons/social/${key}.svg`);
    },

    onTagClick(tag) {
      this.$router.push('/blog?filter=' + tag);
    },

    handleBeFoundClick() {
      this.$router.push({ path: '/be-found' });
    },

    handleShareClick: throttle(function () {
      const url = window.location.href;
      if (navigator?.share) {
        navigator.share({ url }).catch((err) => {
          if (!err.message.includes(WebApiCancelError)) {
            this.$showToastMessage(err.message, 'Error', 'error');
          }
        });
      } else if (navigator?.clipboard) {
        navigator.clipboard
          .writeText(url)
          .then(() =>
            this.$showToastMessage('Link is copied', 'Success', 'success')
          )
          .catch((err) =>
            this.$showToastMessage(
              `Failed to copied link ${err.message}`,
              'Error',
              'error'
            )
          );
      } else {
        this.$showToastMessage(
          `Sharing function is not supported`,
          'Error',
          'error'
        );
      }
    }, 1500),

    getProductFormatPrice(product) {
      const defaultFormat = getDefaultProductFormat(product);
      return formatMoney(
        getFormatPrice(defaultFormat, this.region)?.amount,
        this.currency
      );
    },

    handleBuyNowClick(product) {
      this.buyNowLoading = true;
      this.ADD_ITEM({
        product,
        count: 1,
        productFormatId: getDefaultProductFormat(product)?._id
      });
      this.createSession()
        .then(() => {
          window.location.href = this.redirectUrl;
        })
        .catch((err) => {
          this.$showToastMessage(
            this.$get(err, 'response.data.message'),
            'Error',
            'danger'
          );
        })
        .finally(() => {
          this.buyNowLoading = false;
        });
    },

    handleProductBundleClick(product) {
      this.$router.push({
        path: `/products/${product.id || product.item.id}`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.blog {
  &__header-image {
    object-fit: cover;
    height: 480px;
    width: 100%;
  }

  &__title {
    padding-top: 40px;
    text-align: left;
    line-height: 56px;
  }

  &__landscape-image {
    object-fit: cover;
    transform: translate3d(0, 0, 1px);
    height: 550px;
    width: 100%;
    margin-bottom: 40px;
  }

  &__social {
    position: absolute;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-align: center;

    &-title {
      font-size: 12px;
    }
  }

  &__double-image {
    display: flex;
    justify-content: space-around;

    img {
      object-fit: cover;
      height: 700px;
      &:first-child {
        margin-right: 20px;
      }
    }
  }

  &__quote {
    font-family: 'Poppins-SemiBold', sans-serif;
    font-size: 24px;
    border-left: 8px solid $primary-color;
    padding-left: 35px;
  }

  &__action-button {
    margin: 0 auto;
    max-width: 240px;
  }

  @media (max-width: $screen-width-md) {
    &__header-image {
      object-fit: contain;
      height: 242px;
    }

    &__landscape-image {
      height: 328px;
    }

    &__double-image {
      flex-wrap: wrap;

      img {
        margin-bottom: 25px;
        object-fit: cover;
        height: 420px;
        &:first-child {
          margin-right: 0;
        }
      }
    }

    &__social {
      position: initial;
      flex-direction: column;
      text-align: left;
    }
  }
}
</style>
